import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

// Route path -> permission slug required to open it.
// Add/edit sub-routes inherit their parent module's permission.
const ROUTE_PERMISSIONS = {
  "/": "dashboard",

  "/users": "user-management",
  "/roles": "user-management",
  "/permissions": "user-management",

  "/blog": "blog-management",
  "/add-blog": "blog-management",
  "/edit-blog": "blog-management",
  "/category": "blog-management",
  "/author": "blog-management",
  "/tag": "blog-management",

  "/global-seo": "global-seo",
  "/schema-management": "global-seo",

  "/seo": "seo-management",
  "/add-seo": "seo-management",
  "/edit-seo": "seo-management",

  "/sitemap": "sitemap-management",
  "/llms-management": "llms-management",
  "/robots": "robots-management",

  "/email-management": "email-management",
  "/add-email-management": "email-management",
  "/edit-email-management": "email-management",

  "/faq": "faq-management",
  "/add-faq": "faq-management",
  "/edit-faq": "faq-management",

  "/jobpost": "career",
  "/add-jobpost": "career",
  "/edit-jobpost": "career",
  "/location": "career",
  "/operation": "career",
  "/experience": "career",

  "/job-applications": "job-applications",

  "/case": "case-study",
  "/add-case": "case-study",
  "/edit-case": "case-study",

  "/video": "videos",
  "/add-video": "videos",
  "/edit-video": "videos",

  "/infographic": "infographic",
  "/add-infographic": "infographic",
  "/edit-infographic": "infographic",

  "/eguide": "eguide",
  "/add-eguide": "eguide",
  "/edit-eguide": "eguide",

  "/whitepaper": "whitepaper",
  "/add-whitepaper": "whitepaper",
  "/edit-whitepaper": "whitepaper",

  "/leadership": "leadership",
  "/add-leadership": "leadership",
  "/edit-leadership": "leadership",

  "/newsletter-page": "newsletter-page",
  "/add-newsletter": "newsletter-page",
  "/edit-newsletter": "newsletter-page",

  "/press-release": "press-release",
  "/add-press-release": "press-release",
  "/edit-press-release": "press-release",

  "/contact": "contact-us",

  "/teams": "team",
  "/add-team": "team",
  "/edit-team": "team",
};

// Match by path segments so "/blog" never matches another similarly named route.
const permissionForPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    return ROUTE_PERMISSIONS["/"];
  }

  for (const [key, slug] of Object.entries(ROUTE_PERMISSIONS)) {
    if (key === "/") continue;

    const keySegments = key.split("/").filter(Boolean);
    if (keySegments.every((segment, index) => segments[index] === segment)) {
      return slug;
    }
  }

  return null;
};

// Blocks routes when the current user does not have the module permission.
const RoutePermissionGuard = () => {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  const required = permissionForPath(pathname);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  if (required && !hasPermission(required)) {
    return <AccessDenied />;
  }

  return <Outlet />;
};

export default RoutePermissionGuard;
